export type Granularity = 'day' | 'week' | 'month';

export interface Period {
  id: string;
  label: string;
  days: number;
  granularity: Granularity;
  from: () => Date;
}

const daysAgo = (days: number) => () => new Date(Date.now() - days * 24 * 3600 * 1000);

/**
 * The three views the data is retained for. Nothing longer is offered because
 * analytics events are kept for ~3 months (RETENTION_DAYS server-side).
 */
export const PERIODS: Period[] = [
  { id: 'week', label: 'שבוע אחרון (לפי יום)', days: 7, granularity: 'day', from: daysAgo(7) },
  { id: 'month', label: 'חודש אחרון (לפי שבוע)', days: 30, granularity: 'week', from: daysAgo(30) },
  { id: 'quarter', label: '3 חודשים (לפי חודש)', days: 91, granularity: 'month', from: daysAgo(91) },
];
